import React, { useRef } from "react";
import { useOutsideClick } from "../../../helpers/util";
import HeaderProfilePopupContent from "./headerProfilePopupContent";
import icon from "../../header/img/no-profile-photo.png";
import "./scss/style.scss";

const HeaderProfilePopup = ({ item, hideSubmenu }) => {
  const profileDetailsRef = useRef();
  useOutsideClick(profileDetailsRef);

  return (
    <div className="yettel-profile-menu">
      <details ref={profileDetailsRef} data-popover="down">
        <summary className="d-block pr-1 pt-1 p-0" key={item.id}>
          <div className="ytl-icon-container"></div>
          <img className="icon" alt={'alt'} src={icon}/>
        </summary>
        <div className='ytl-popover-menu'>
          <HeaderProfilePopupContent item={item} hideSubmenu={hideSubmenu}/>
        </div>
      </details>
    </div>
  );
};

export default HeaderProfilePopup;
